import { Button, Flex } from "@chakra-ui/react";
import UTMLink from "@components/UTMLink";
import Image from "next/image";

const Header = () => {
  return (
    <Flex
      justifyContent="space-between"
      p={{ base: "16px", md: "24px 40px" }}
      alignItems="center"
      maxW="1512px"
      w="full"
    >
      <Image
        src="/assets/kelp.svg"
        alt="kelp"
        height={40}
        width={106}
        loading="eager"
      />

      <UTMLink
        href="/restake"
        _hover={{
          borderBottom: "none",
        }}
      >
        <Button
          variant="unstyled"
          p={{ base: "8px 36px", md: "16px 64px" }}
          border="1px solid"
          borderRadius="16px"
          h={{ base: "42px", md: "56px" }}
          fontSize="14px"
          fontWeight="600"
          lineHeight="24px"
        >
          Restake now
        </Button>
      </UTMLink>
    </Flex>
  );
};

export default Header;
